module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Black-8e5479279b074720e15f0f5df18aff39.ttf";